module.exports = __webpack_public_path__ + "static/media/nuevo-white.b1bda041.svg";